import { render } from "./p-date-range-widget.vue?vue&type=template&id=708ecbda"
import script from "./p-date-range-widget.vue?vue&type=script&lang=js"
export * from "./p-date-range-widget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__